import {
  Decoration,
  type DecorationSet,
  type EditorView,
  MatchDecorator,
  ViewPlugin,
  type ViewUpdate,
} from '@codemirror/view'

import { isValidVariableContent } from './template-variable-validation.util'

const VARIABLE_PATTERN = /\{[^{}]+\}/g

const validDecoration = Decoration.mark({
  class: 'cm-template-variable cm-template-variable-valid',
})
const invalidDecoration = Decoration.mark({
  class: 'cm-template-variable cm-template-variable-invalid',
})

const variableMatcher = new MatchDecorator({
  regexp: VARIABLE_PATTERN,
  decoration: (match) => {
    const inner = match[0].slice(1, -1)
    return isValidVariableContent(inner) ? validDecoration : invalidDecoration
  },
})

/**
 * CodeMirror 6 ViewPlugin that highlights template variables {variableName:type:...}
 * as inline badges. Valid variables get blue styling, invalid ones get red styling.
 */
export const templateVariableHighlightPlugin = ViewPlugin.fromClass(
  class {
    decorationSet: DecorationSet
    constructor(view: EditorView) {
      this.decorationSet = variableMatcher.createDeco(view)
    }
    update(update: ViewUpdate) {
      this.decorationSet = variableMatcher.updateDeco(update, this.decorationSet)
    }
  },
  {
    decorations: (instance) => instance.decorationSet,
  }
)
